import type { AxiosInstance } from 'axios';
import type { Users } from './interfaces';
import { transformDates } from './transformers';

export interface GetUserBrandsResponse {
  brands: {
    identifier: string;
    name: string;
  }[];
}

export interface GetUserApplicationsResponse {
  // Map of brand identifier to applications for that brand
  [brandIdentifier: string]: {
    identifier: string;
    name: string;
    icon: string | null;
    isDefault?: boolean;
  }[];
}
export interface GetUserRateLimitingResponse {
  allowed: boolean;
  limit: number | null;
  current: number;
}

export class UsersClient {
  constructor(private authenticatedClient: AxiosInstance) { }

  getUserBrands = async (): Promise<GetUserBrandsResponse> => {
    const response = await this.authenticatedClient.get<GetUserBrandsResponse>('/users/brands');
    return response.data;
  };

  getUserApplications = async (): Promise<GetUserApplicationsResponse> => {
    const response = await this.authenticatedClient.get<GetUserApplicationsResponse>('/users/applications');
    return response.data;
  };

  getRecentFiles = () => {
    return this.authenticatedClient.get<Users.GetRecentFiles.Response>(`/users/recent-files`, {
      transformResponse: transformDates,
    });
  };

  getRateLimiting = async (): Promise<GetUserRateLimitingResponse> => {
    const response = await this.authenticatedClient.get<GetUserRateLimitingResponse>('/users/rate-limiting');
    return response.data;
  };
}

export default UsersClient;